import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import memoize from 'transmute/memoize';
import { jsx as _jsx } from "react/jsx-runtime";
const renderFormattedHTMLMessage = key => /*#__PURE__*/_jsx(FormattedHTMLMessage, {
  message: key
});
export const getDeleteCommentTranslations = memoize(() => {
  return {
    confirmLabel: renderFormattedHTMLMessage('timeline.deleteModal.buttonText'),
    description: renderFormattedHTMLMessage('timeline.deleteModal.deleteComment.message'),
    message: renderFormattedHTMLMessage('timeline.deleteModal.title'),
    successfulDelete: renderFormattedHTMLMessage('timeline.deleteModal.deleteComment.successfulDelete'),
    failedDelete: renderFormattedHTMLMessage('timeline.deleteModal.deleteComment.failedDelete'),
    rejectLabel: renderFormattedHTMLMessage('timeline.deleteModal.rejectButtonText')
  };
});